import React from 'react';
import { Form as AntdForm } from 'antd';

// https://ant.design/components/form/#components-form-demo-basic
const Form = ({
  initialValues,
  onFinish,
  onFinishFailed,
  children,
  ...rest
}) => {
  // Find the first ancestor with the class name
  function findAncestor(el, cls) {
    while (el && !el.classList.contains(cls)) {
      el = el.parentElement;
      if (!el) break;
    }
    return el;
  }

  const customScrollToFirstError = () => {
    setTimeout(() => {
      // Scroll to the first error message
      const firstErrorElement = document.getElementsByClassName(
        'ant-form-item-explain-error',
      )[0];
      if (firstErrorElement) {
        const ancestor = findAncestor(firstErrorElement, 'ant-row');
        ancestor?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleFinishFailed = (errorInfo) => {
    customScrollToFirstError();
    if (typeof onFinishFailed === 'function') {
      onFinishFailed(errorInfo);
    }
  };

  return (
    <AntdForm
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
      scrollToFirstError={false}
      onFinishFailed={handleFinishFailed}
      {...rest}
    >
      {children}
    </AntdForm>
  );
};

export default Form;
